import constants from "../../../core/constants";
import isNil from "lodash/fp/isNil";

class Controller {
  constructor($mdDialog, Events, type, types, systemCategories) {
    "ngInject";

    this.type = type;
    this.types = types;
    this.systemCategories = systemCategories;
    this.selectedCategory = undefined;
    this.$mdDialog = $mdDialog;
    this.Events = Events;

    this.confirmEvent = this.Events.getUpdateEvent("confirmAdjustment");
  }

  $onInit() {
    this.invoicesList = this.types;

    this.Events.on(this.confirmEvent, this.confirm.bind(this));
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    const type = this.invoiceType.key;
    if (!isNil(this.fields[type].amount)) {
      this.fields[type].amount *= constants.currencyBy;
    }
    if (!isNil(this.selectedCategory)) {
      this.fields[type].category_id = this.selectedCategory.id;
    }
    this.$mdDialog.hide({
      type,
      ...this.fields[type],
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/invoice/manualDialog/manualDialog.controller.js